import { getAngularService, AngularServices, } from '../../core/helpers/get-angular-service';
export const fetch = () => async (dispatch) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    const ssoServices = await api.find().$promise;
    dispatch({
        type: 'SSO/SET_SERVICES',
        payload: ssoServices,
    });
};
export const fetchById = (id) => async (dispatch) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    const ssoService = await api.findById({ id }).$promise;
    dispatch({
        type: 'SSO/UPDATE_SERVICE',
        payload: ssoService,
    });
};
export const create = (data) => async (dispatch) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    const ssoService = await api.create(data).$promise;
    dispatch({
        type: 'SSO/ADD_SERVICE',
        payload: ssoService,
    });
};
export const deleteById = (id) => async (dispatch) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    await api.deleteById({ id }).$promise;
    dispatch({
        type: 'SSO/REMOVE_SERVICE',
        payload: id,
    });
};
export const update = (id, data) => async (dispatch) => {
    const api = getAngularService(AngularServices.SsoServiceApi);
    const ssoService = await api.prototype$updateAttributes({ id }, data)
        .$promise;
    dispatch({
        type: 'SSO/UPDATE_SERVICE',
        payload: ssoService,
    });
};
